import React from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { EditFormDetails } from "../interfaces";

export const SelectNbStars = ({
  filter,
  field,
  helpers,
  classes,
  multipleSelection,
}: {
  filter: EditFormDetails;
  field: any;
  helpers: any;
  classes: any;
  multipleSelection: boolean;
}) => {
  return (
    <FormControl
      className={classes.select}
      disabled={filter.readonly}
      fullWidth
      variant="outlined"
    >
      <InputLabel id="select-nb-stars">
        <FormattedMessage id={filter.label} />
      </InputLabel>
      <Select
        labelId="select-nb-stars-label"
        id="select-nb-stars"
        value={field.value}
        onChange={(value) => helpers.setValue(value.target.value)}
      >
        {multipleSelection && <MenuItem value={-1}>--</MenuItem>}
        <MenuItem value={0}>0</MenuItem>
        <MenuItem value={1}>1</MenuItem>
        <MenuItem value={2}>2</MenuItem>
        <MenuItem value={3}>3</MenuItem>
        <MenuItem value={4}>4</MenuItem>
        <MenuItem value={5}>5</MenuItem>
      </Select>
    </FormControl>
  );
};
